const OFFICIAL_SITE = 'https://www.mazhizuo.com/'
const BLOCK_LAYER_ID = 'tool-page-guard-block'
const BODY_CLASS = 'tool-page-protected'

const listeners = []
let active = false
let verifyTimer = null
let blocked = false

function isEditableTarget(target) {
  if (!target || !target.closest) return false
  const tag = target.tagName
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true
  if (target.isContentEditable) return true
  return !!target.closest('input, textarea, select, [contenteditable="true"], .allow-copy')
}

function isAllowedProtocol(protocol) {
  return protocol === 'http:' || protocol === 'https:'
}

function isAllowedHost(hostname) {
  const host = (hostname || '').toLowerCase()
  if (!host) return false
  if (host === 'localhost' || host === '127.0.0.1') return true
  if (host === 'mazhizuo.com' || host.endsWith('.mazhizuo.com')) return true
  // 扫码泛域防封（如 *.mazhizuo.cn）
  if (host === 'mazhizuo.cn' || host.endsWith('.mazhizuo.cn')) return true
  return false
}

function isEmbeddedInIframe() {
  try {
    return window.self !== window.top
  } catch (err) {
    return true
  }
}

export function verifyToolPageEnvironment() {
  const { protocol, hostname } = window.location

  if (protocol === 'file:') {
    return { ok: false, reason: 'file-protocol' }
  }

  if (!isAllowedProtocol(protocol)) {
    return { ok: false, reason: 'invalid-protocol' }
  }

  if (process.env.NODE_ENV !== 'production') {
    return { ok: true }
  }

  if (!isAllowedHost(hostname)) {
    return { ok: false, reason: 'invalid-host' }
  }

  return { ok: true }
}

const BLOCK_MESSAGES = {
  'file-protocol': {
    title: '无法离线使用',
    desc: '检测到通过本地文件打开页面。在线工具需在码智作官网环境中运行，请前往官网使用。'
  },
  'invalid-protocol': {
    title: '访问环境异常',
    desc: '当前协议不受支持。请通过码智作官网正常访问在线工具。'
  },
  'invalid-host': {
    title: '未经授权的访问',
    desc: '在线工具仅限在码智作官方域名下使用，即将跳转到官网。'
  },
  iframe: {
    title: '禁止嵌入使用',
    desc: '请勿将本工具嵌入第三方页面。请直接访问码智作官网使用在线工具。'
  }
}

function hideBlockLayer() {
  const layer = document.getElementById(BLOCK_LAYER_ID)
  if (layer) layer.remove()
  blocked = false
}

function showBlockLayer(reason) {
  const message = BLOCK_MESSAGES[reason] || BLOCK_MESSAGES['invalid-host']
  blocked = true

  let layer = document.getElementById(BLOCK_LAYER_ID)
  if (!layer) {
    layer = document.createElement('div')
    layer.id = BLOCK_LAYER_ID
    layer.className = 'tool-page-guard-block'
    document.body.appendChild(layer)
  }

  layer.innerHTML = [
    '<div class="tool-page-guard-block__panel">',
    '  <p class="tool-page-guard-block__title">' + message.title + '</p>',
    '  <p class="tool-page-guard-block__desc">' + message.desc + '</p>',
    '  <a class="tool-page-guard-block__link" href="' + OFFICIAL_SITE + '" target="_blank" rel="noopener noreferrer">前往码智作官网</a>',
    '</div>'
  ].join('')

  if (reason === 'invalid-host' && process.env.NODE_ENV === 'production') {
    window.setTimeout(function() {
      window.location.replace(OFFICIAL_SITE)
    }, 1800)
  }
}

function addListener(event, handler, options) {
  document.addEventListener(event, handler, options)
  listeners.push({ event, handler, options })
}

function onContextMenu(e) {
  if (!active || blocked) return
  if (isEditableTarget(e.target)) return
  e.preventDefault()
}

function onCopyCut(e) {
  if (!active || blocked) return
  if (isEditableTarget(e.target)) return
  e.preventDefault()
}

function onSelectStart(e) {
  if (!active || blocked) return
  if (isEditableTarget(e.target)) return
  e.preventDefault()
}

function onDragStart(e) {
  if (!active || blocked) return
  if (isEditableTarget(e.target)) return
  e.preventDefault()
}

function onKeyDown(e) {
  if (!active || blocked) return
  if (isEditableTarget(e.target)) return

  const key = e.key ? e.key.toLowerCase() : ''
  const ctrl = e.ctrlKey || e.metaKey
  const shift = e.shiftKey

  if (key === 'f12') {
    e.preventDefault()
    return
  }

  if (!ctrl) return

  const code = e.keyCode || e.which
  if (code === 83 || key === 's') {
    e.preventDefault()
    return
  }
  if (code === 85 || key === 'u') {
    e.preventDefault()
    return
  }
  if (shift && (code === 73 || code === 74 || code === 67 || key === 'i' || key === 'j' || key === 'c')) {
    e.preventDefault()
  }
}

function attachProtectionHandlers() {
  addListener('contextmenu', onContextMenu)
  addListener('copy', onCopyCut)
  addListener('cut', onCopyCut)
  addListener('selectstart', onSelectStart)
  addListener('dragstart', onDragStart)
  addListener('keydown', onKeyDown, true)
}

function detachProtectionHandlers() {
  listeners.forEach(function(item) {
    document.removeEventListener(item.event, item.handler, item.options)
  })
  listeners.length = 0
}

function clearVerifyTimer() {
  if (verifyTimer) {
    clearInterval(verifyTimer)
    verifyTimer = null
  }
}

function runEnvironmentCheck() {
  const env = verifyToolPageEnvironment()
  if (!env.ok) {
    showBlockLayer(env.reason)
    return false
  }

  if (isEmbeddedInIframe()) {
    showBlockLayer('iframe')
    return false
  }

  hideBlockLayer()
  return true
}

export function enableToolPageProtection() {
  if (active) return
  active = true
  document.body.classList.add(BODY_CLASS)

  if (!runEnvironmentCheck()) {
    attachProtectionHandlers()
    verifyTimer = window.setInterval(runEnvironmentCheck, 15000)
    return
  }

  attachProtectionHandlers()
  verifyTimer = window.setInterval(runEnvironmentCheck, 15000)
}

export function disableToolPageProtection() {
  if (!active) return
  active = false
  blocked = false
  document.body.classList.remove(BODY_CLASS)
  detachProtectionHandlers()
  clearVerifyTimer()
  hideBlockLayer()
}

export function syncToolPageProtection(shouldProtect) {
  if (shouldProtect) {
    enableToolPageProtection()
  } else {
    disableToolPageProtection()
  }
}

export function isToolRoute(route) {
  if (!route || !route.matched) return false
  return route.matched.some(function(record) {
    return record.meta && record.meta.toolPage
  })
}
